/**
 * Класс реализует функционал выполнения попыток выполнения чего либо (подключения к внешнему сервису)
 * Так же класс позволяет наполничть очередь объектами, ожидающими этого выполнения
 */
export class QueuedAttempts<T> {
    protected readonly queue: T[] = [];
    protected intervalTimer: any;
    protected isInstalled: boolean = false;

    /**
     * @param attempts      Общее кол-во попыток
     * @param interval_ms   Интервал
     * @param owner         Указание владельца для кастомизации сообщений
     */
    constructor(
        protected attempts: number,
        protected interval_ms: number,
        protected readonly owner: string = ''
    ) {}

    /**
     * Запускаем setInterval с проверкой callback в заданные интервалы
     * Если callback вернул true, итерации прекращаются и устанавливается флаг isInstalled
     *
     * @param checkIsInstalledCallback
     */
    public makeLoop(checkIsInstalledCallback: () => boolean): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.intervalTimer = setInterval(() => {
                // If OK or attempts were exhausted
                if (checkIsInstalledCallback()) {
                    resolve();
                    this.end();
                } else if (!--this.attempts) {
                    reject(
                        `${
                            this.owner ? this.owner + ': ' : ''
                        }Attempts exhausted`
                    );
                    this.end();
                }
            }, this.interval_ms);
        }).then(() => {
            this.isInstalled = true;
        });
    }

    /**
     * Остановить итерации
     *
     * Если этот метод делать публичным, то надо обработать makeLoop rejection, иначе promise никогда не сменит статус
     */
    protected end() {
        clearInterval(this.intervalTimer);
    }

    public addToQueue(item: T) {
        this.queue.push(item);
    }

    public getQueue(): T[] {
        return this.queue;
    }

    public getIsInstalled() {
        return this.isInstalled;
    }
}
